import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import DynamicForm1 from "./DynamicForm1";
import DynamicForm2 from "./DynamicForm2";
import DynamicForm3 from "./DynamicForm3";
import DynamicForm4 from "./DynamicForm4";
import DynamicForm5 from "./DynamicForm5";
import DynamicForm6 from "./DynamicForm6";
import Demo from "./Demo";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
